import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { TableRowData } from './tableData';

export const EnergySourcesTable = ({ data, colWidths }: { data: TableRowData[]; colWidths?: number[] }) => {
  const { t } = useTranslation();

  return (
    <Table id="energy-sources-table" sx={{ tableLayout: 'fixed', width: '100%' }}>
      <colgroup>
        {colWidths?.map((width, index) => (
          <col key={index} style={{ width: `${width}%` }} />
        ))}
      </colgroup>

      <TableHead>
        <TableRow
          sx={{
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <TableCell>
            <Typography variant="caption" fontWeight="600">
              {t('blueprints:details.table.energySources.title')}
            </Typography>
          </TableCell>

          {['blueprints:details.table.projectWithoutBattery', 'blueprints:details.table.greenerHybridSetup'].map(
            (key) => (
              <TableCell key={key}>
                <Typography variant="caption" color="grey.600">
                  {t(key)}
                </Typography>
              </TableCell>
            )
          )}

          <TableCell aria-hidden="true" sx={{ border: 'none' }} />
        </TableRow>
      </TableHead>

      <TableBody>
        {data.map((row, index) => {
          const hasBottomBorder = index < data.length - 1;

          return (
            <TableRow
              key={index}
              sx={{
                borderBottom: hasBottomBorder ? (theme) => `1px solid ${theme.palette.grey[200]}` : 'none',
              }}
            >
              <TableCell sx={{ border: 'none' }}>
                <Typography variant="body2" color="text.secondary">
                  {row.label}
                </Typography>
              </TableCell>

              <TableCell sx={{ border: 'none' }}>
                <Typography variant="body2" component="div">
                  {row.baseValue}
                </Typography>
              </TableCell>

              <TableCell sx={{ border: 'none' }}>
                <Typography variant="body2" component="div">
                  {row.hybridValue}
                </Typography>
              </TableCell>

              <TableCell aria-hidden="true" sx={{ border: 'none' }} />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
